export default "__VITE_ASSET__0RUyxI9i__"